import { render } from "./StuffTypeIndex.vue?vue&type=template&id=31425d30"
import script from "./StuffTypeIndex.vue?vue&type=script&lang=js"
export * from "./StuffTypeIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__